import { useCallback } from "react";
import { useLocalStorage } from "./useLocalStorage";

const KEY = "sacristy.dismissed-cards.v1";

// Card IDs Colleen has dismissed from "Needs your attention." Only
// reminder-flavor cards (outreach_pending, quarter_prep) get a
// dismiss affordance — those don't tie to an open gap that might
// still need work. Stale sub-requests stay non-dismissable so they
// can't be hidden accidentally.
//
// Dismissal is persisted in localStorage, scoped to this browser/
// account. The underlying state (outreach sends, the quarterly
// deadline) is untouched — the card just stops surfacing.

export function useDismissedCards() {
  const [ids, setIds] = useLocalStorage<string[]>(KEY, []);
  const dismissed = new Set(ids);

  const dismiss = useCallback(
    (cardId: string) => setIds((prev) => (prev.includes(cardId) ? prev : [...prev, cardId])),
    [setIds],
  );

  const undismiss = useCallback(
    (cardId: string) => setIds((prev) => prev.filter((id) => id !== cardId)),
    [setIds],
  );

  const isDismissed = (cardId: string) => dismissed.has(cardId);

  return { dismiss, undismiss, isDismissed };
}
